import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { GAME_SESSION_ACTION_TYPE, GameSessionAction } from "./game-session.action";
import { CloseGameSessionPayload } from "./game-session.model";
import { GameSessionService } from "./game-session.service";

@Injectable()
export class GameSessionEffect {
	closeGameSession$ = createEffect(() =>
		this.actions$.pipe(
			ofType(GAME_SESSION_ACTION_TYPE.closeGameSession),
			switchMap((action: ActionWithPayload<CloseGameSessionPayload>) =>
				this.gameSessionService.closeGameSession(action.payload).pipe(
					map((response) => {
						return this.action.closeGameSessionSuccess(response);
					}),
					catchError(() => of(this.action.closeGameSessionFail()))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: GameSessionAction,
		private gameSessionService: GameSessionService
	) {}
}
